import * as THREE from 'three';

// Loads what tools/build-pinball.mjs prepared for visualizers/pinball.js -
// the playfield photos (off and on, flippers inpainted), the lossless id map
// (R = insert id, G = ramp mask), the flipper sprite sheet - ONCE, at
// startup. Same preload/get shape as startrails-assets.js and the same rule:
// a WIRING POINT every entry point calls; it resolves false when anything is
// missing so the entry point withdraws Pinball (the brief's fallback).
const MANIFEST_URL = 'textures/pinball.json';

let _assets = null;
let _promise = null;

function loadTexture(url, configure) {
  return new Promise(function (resolve, reject) {
    new THREE.TextureLoader().load(url, function (t) { configure(t); t.needsUpdate = true; resolve(t); }, undefined, function () {
      reject(new Error(url + ' failed to load'));
    });
  });
}
function photo(t) {
  t.colorSpace = THREE.SRGBColorSpace;
  t.generateMipmaps = false;
  t.minFilter = THREE.LinearFilter;
  t.magFilter = THREE.LinearFilter;
  t.wrapS = t.wrapT = THREE.ClampToEdgeWrapping;
}
// the id map: exact integers, never filtered
function ids(t) {
  t.colorSpace = THREE.NoColorSpace;
  t.generateMipmaps = false;
  t.minFilter = THREE.NearestFilter;
  t.magFilter = THREE.NearestFilter;
  t.wrapS = t.wrapT = THREE.ClampToEdgeWrapping;
}
function sprite(t) {
  photo(t);
  t.premultiplyAlpha = false;
}

export function preloadPinball() {
  if (_promise) return _promise.then(function (a) { return !!a; });
  _promise = fetch(MANIFEST_URL)
    .then(function (r) {
      if (!r.ok) throw new Error('pinball.json HTTP ' + r.status);
      return r.json();
    })
    .then(function (manifest) {
      return Promise.all([
        loadTexture('textures/' + manifest.off, photo),
        loadTexture('textures/' + manifest.on, photo),
        loadTexture('textures/' + manifest.ids, ids),
        loadTexture('textures/' + manifest.flippersPng, sprite)
      ]).then(function (parts) {
        _assets = { manifest: manifest, off: parts[0], on: parts[1], ids: parts[2], flippers: parts[3] };
        return _assets;
      });
    })
    .catch(function (err) {
      console.error('[party-mode] pinball assets unavailable, Pinball is withdrawn', err);
      _assets = null;
      return null;
    });
  return _promise.then(function (a) { return !!a; });
}

export function getPinball() {
  return _assets;
}
